import React from 'react'
import {
  func, array, number, bool, string,
} from 'prop-types'
import {
  Checkbox, Button,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Icon from 'Pods/Shared/Icon/Icon'

import ValidationErrors from './Components/ValidationErrors'
import SummaryTable from './Components/SummaryTable'
import DurationSection from './Components/DurationSection'
import PromotionStatusTag from '../../../PromotionStatusTag'

function PromoteModelSidebar({
  tagsLoading,
  selectedTags,
  duration,
  onDurationChange,
  calculateTotalCost,
  canStartCampaign,
  onStartCampaignClick,
  salesBoostPoints,
  validationErrors,
  contentPolicyAgreed,
  toggleContentPolicyAgreement,
  limitTagCampaignsAndCostInflation = false,
  isReadOnly = false,
  promotionStatus = 'Active',
  submittingCampaign = false,
}) {
  const totalCost = calculateTotalCost()
  const totalCostPerDay = Math.round(totalCost / duration)

  const tagsWithoutPenalty = limitTagCampaignsAndCostInflation
    ? selectedTags.filter(tag => tag.penalty === 0)
    : selectedTags
  const tagsWithPenalty = limitTagCampaignsAndCostInflation
    ? selectedTags.filter(tag => tag.penalty > 0)
    : []
  const hasAnyTagsWithPenalty = tagsWithPenalty.length > 0

  return (
    <div className="promote-modal__sidebar">
      <div className="promote-modal__summary">
        <h3 className="promote-modal__section-title">Campaign summary</h3>
        <div className="promote-modal__summary-card">
          <SummaryTable
            tagsLoading={tagsLoading}
            tagsWithoutPenalty={tagsWithoutPenalty}
            tagsWithPenalty={tagsWithPenalty}
            hasAnyTagsWithPenalty={hasAnyTagsWithPenalty}
            limitTagCampaignsAndCostInflation={limitTagCampaignsAndCostInflation}
            totalCostPerDay={totalCostPerDay}
          />
          <DurationSection
            duration={duration}
            onDurationChange={onDurationChange}
            isReadOnly={isReadOnly}
            tagsLoading={tagsLoading}
          />
          <div className="promote-modal__summary-section promote-modal__summary-section--total">
            <div className="promote-modal__summary-row">
              <span className="promote-modal__summary-key">Total cost</span>
              {!tagsLoading && (
                <span className="promote-modal__summary-total">{totalCost} credits</span>
              )}
            </div>
          </div>
        </div>
        {!isReadOnly && (
          <Checkbox
            checkedColor="primary"
            id="content-policy-checkbox-sidebar"
            className="promote-modal__content-policy-checkbox"
            label={(
              <span>
                I confirm that this model DOESN'T infringe{' '}
                <a
                  className="promote-modal__policy-link"
                  href="/pages/cgtrader-content-policy"
                  target="_blank"
                  rel="noreferrer"
                >
                  CGTrader Content Policy
                  {' '}
                  <Icon
                    type={['fas', 'external-link']}
                    className="promote-modal__policy-link-icon"
                  />
                </a>
              </span>
            )}
            isChecked={contentPolicyAgreed}
            onChange={toggleContentPolicyAgreement}
            isControlled
          />
        )}
        {!isReadOnly && (
          <Button
            onClick={onStartCampaignClick}
            disabled={!canStartCampaign() || submittingCampaign}
          >
            {submittingCampaign ? 'Launching...' : 'Launch campaign'}
          </Button>
        )}
        {!isReadOnly && <ValidationErrors errors={validationErrors} />}
        {isReadOnly ? (
          <div className="promote-modal__campaign-status">
            <span className="promote-modal__campaign-status-label">Status of the campaign</span>
            <PromotionStatusTag promotionStatus={promotionStatus} />
          </div>
        ) : (
          <div className="promote-modal__balance">
            <span className="promote-modal__balance-label">Remaining balance</span>
            <span className="promote-modal__balance-value">{salesBoostPoints} credits</span>
          </div>
        )}
      </div>
    </div>
  )
}

PromoteModelSidebar.propTypes = {
  tagsLoading: bool.isRequired,
  selectedTags: array.isRequired,
  duration: number.isRequired,
  onDurationChange: func.isRequired,
  calculateTotalCost: func.isRequired,
  canStartCampaign: func.isRequired,
  onStartCampaignClick: func.isRequired,
  salesBoostPoints: number.isRequired,
  validationErrors: array.isRequired,
  contentPolicyAgreed: bool.isRequired,
  toggleContentPolicyAgreement: func.isRequired,
  limitTagCampaignsAndCostInflation: bool,
  isReadOnly: bool,
  promotionStatus: string,
  submittingCampaign: bool,
}

export default PromoteModelSidebar
